import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import Button from '@/components/Button';
import { IconCalendarEvent } from '@/components/icon/tabler/IconCalendarEvent';
import { IconPlus } from '@/components/icon/tabler/IconPlus';
import { useTranslate } from '@/state/i18n';

interface Props {
  /** The account has events, but none in the selected tab. */
  filtered: boolean;
  onCreate: () => void;
}

/** Empty list (P16): no events yet, with the first call to action, or an empty tab. */
const EventsEmptyState = ({ filtered, onCreate }: Props) => {
  const t = useTranslate('domain.events.components.EventsEmptyState');

  return (
    <Stack alignItems="center" textAlign="center" gap={1.5} sx={{ py: 8, px: 2 }}>
      <IconCalendarEvent color="primary" sx={{ fontSize: 32 }} />
      <Typography variant="subtitle1" fontWeight={600}>
        {filtered ? t('filteredTitle') : t('title')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 420 }}>
        {filtered ? t('filteredHint') : t('hint')}
      </Typography>
      {filtered ? null : (
        <Button variant="contained" startIcon={<IconPlus />} onClick={onCreate}>
          {t('create')}
        </Button>
      )}
    </Stack>
  );
};

export default EventsEmptyState;
